'use client'

import { useEffect, useState } from 'react'
import PageBanner from '@/components/features/PageBanner'
import Link from 'next/link'
import { Home } from 'lucide-react'

interface Link {
  id: number
  name: string
  url: string
  sort_order: number
}

export default function LinksPage() {
  const [links, setLinks] = useState<Link[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchLinks()
  }, [])

  const fetchLinks = async () => {
    try {
      const res = await fetch('/api/links')
      const data = await res.json()
      if (data.success) {
        setLinks(data.links)
      }
    } catch (error) {
      console.error('Error fetching links:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 pt-24">
        <PageBanner 
          title="友好連結" 
          subtitle="精選實用網站，一站掌握重要資源"
        />
        <div className="container mx-auto px-4 py-12">
          <div className="text-center">載入中...</div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      <PageBanner 
        title="友好連結" 
        subtitle="精選實用網站，一站掌握重要資源"
      />
      
      <div className="container mx-auto px-4 py-12">
        <Link 
          href="/" 
          className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
        >
          <Home className="w-4 h-4" />
          回首頁
        </Link>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {links.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow"
            >
              <h2 className="text-xl font-semibold text-gray-900 mb-2">{link.name}</h2>
              <p className="text-teal-600 hover:text-teal-800 text-sm truncate">
                {link.url}
              </p>
            </a>
          ))}
        </div>

        {links.length === 0 && (
          <div className="text-center text-gray-500">
            目前沒有任何連結
          </div>
        )}
      </div>
    </div>
  )
} 